import { VenueConnectVenueInput, VenueConnectVenueMutation } from '../../graphql/API';
import { venueConnectVenue } from '../../graphql/mutations';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const venueConnectVenueApi = async (
  input: VenueConnectVenueInput,
): Promise<VenueConnectVenueMutation['venueConnectVenue']> => {
  const result = await executeGql<VenueConnectVenueMutation>(venueConnectVenue, { input });
  return processGqlResult<VenueConnectVenueMutation['venueConnectVenue']>(
    'venueConnectVenue',
    result,
  );
};
